<template>
    <div class="sustainable-component competence-admin-competence-category">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component competence-admin-competence-category</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-10">
                    {{categoryname}}
                </div>
                <div class="col-2">
                    <div class="dropdown text-right pr-2" v-if="disabled == false">
                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                            ...
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a href="javascript:void(0)" class="dropdown-item" @click="updateCategory">Ändra</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3 align-items-start">
                <div class="col-12 col-md-8 mb-2 mb-md-0">
                    <v-text-field v-bind:disabled="disabled"
                                  bg-color="white"
                                  label="Ange"
                                  v-model="competencename"
                                  variant="outlined"
                                  density="compact"
                                  hide-details></v-text-field>
                </div>
                <div class="col-12 col-md-4">
                    <v-btn v-bind:disabled="disabled"
                           size="default"
                           color="primary"
                           class="btn-primary competence-add-button"
                           @click="addCompetence">
                        Spara ny
                    </v-btn>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col">
                    <table class="table table-light table-hover table-striped competence-list-table"
                           cellspacing="0"
                           cellpadding="8"
                           border="0">
                        <thead>
                            <tr>
                                <th class="competence-list-name" style="font-weight:normal">Utbildning</th>
                                <th class="competence-list-action"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in competencelist" :key="index">
                                <td class="competence-list-name">
                                    <span>{{ item.Name }}</span>
                                </td>
                                <td class="competence-list-action">
                                    <div class="dropdown text-right" v-if="disabled == false">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateCompetenceItem(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="removeCompetence(item.CompetenceId)">Ta bort</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <UpdateCompetenceCategory2 v-bind:disabled="disabled" ref="updateCompetenceCategoryModal" @updated="updated"></UpdateCompetenceCategory2>
        <UpdateCompetence v-bind:disabled="disabled" ref="updateCompetenceModal" @updated="updated"></UpdateCompetence>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import CompetenceService from "../../Services/CompetenceService";
    import UpdateCompetenceCategory2 from './update/competence-update-competence-category2.vue'
    import UpdateCompetence from './update/competence-update-competence.vue'
    import CommonSpinner from '../../common/common-spinner.vue'

    import { ref } from 'vue'

    const updateCompetenceCategoryModal = ref(null);
    const updateCompetenceModal = ref(null);


    export default {

        name: 'competence-admin-competence-category',
        emits: ['updated'],
        props: {
            model: Object,
            competencecategoryid: Number,
            categoryname: String,
            competencelist: Array,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            UpdateCompetenceCategory2,
            UpdateCompetence,
            CommonSpinner
        },
        methods: {
            updated(){
                this.$emit('updated')
            },
            async addCompetence() {
                if (this.competencename == null || this.competencename == "") {
                    alert("Ange ett namn på kompetensen");
                    return;
                }
                this.loading++;
                try {
                    await CompetenceService.addCompetence(this.competencecategoryid, this.competencename);
                    this.displaySnackBar("Kompetensen lades till");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.$emit('updated')
                this.loading--;
            },
            async removeCompetence(id) {
                if (confirm(" Är du säker att du vill radera kompetensen?")) {
                    this.loading++;
                    try {
                        await CompetenceService.deleteCompetence(id);
                        this.displaySnackBar("Kompetensen togs bort");
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.$emit('updated')
                    this.loading--;
                }
            },
            updateCompetenceItem(item) {
                this.loading++;
                this.updateCompetenceModal.open(item);
                this.loading--;
            },
            updateCategory() {
                this.loading++;
                try {
                    this.updateCompetenceCategoryModal.open(this.competencecategoryid, this.categoryname);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },

        },

        data() {
            return {
                competencename:null,
                rules: ValidationService.rules(),
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            

        },
        mounted() {
            this.internalModel = this.model;
        },
        setup() {
            return { updateCompetenceCategoryModal, updateCompetenceModal }
        }
    }
</script>

<style scoped>
    .competence-list-table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
    }

    .competence-list-name {
        width: auto;
        min-width: 0;
        word-break: break-word;
        overflow-wrap: anywhere;
        vertical-align: middle;
    }

    .competence-list-action {
        width: 2.5rem;
        white-space: nowrap;
        text-align: right;
        vertical-align: middle;
    }

    .competence-add-button {
        width: 100%;
    }

    @media (min-width: 768px) {
        .competence-add-button {
            width: auto;
        }

        .mb-md-0 {
            margin-bottom: 0 !important;
        }
    }
</style>
